import { MARQUEE } from "@/data/site";

export const Marquee = () => {
  const row = [...MARQUEE, ...MARQUEE];
  return (
    <section data-testid="marquee-section" aria-hidden="true" className="py-10 sm:py-14 overflow-hidden border-y border-[#111511]/[0.06]">
      <div className="flex w-max marquee-track">
        {row.map((t, i) => (
          <span key={i} className={`flex items-center gap-10 pr-10 font-head font-semibold tracking-[-0.04em] text-4xl sm:text-6xl lg:text-7xl whitespace-nowrap ${i % 2 ? "text-outline" : "text-[#111511]"}`}>
            {t} <span className="w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-[#9CC26A]" />
          </span>
        ))}
      </div>
    </section>
  );
};
